<template>
	<form class="form-horizontal" @submit.prevent="save">
		<div class="animated fadeIn">
			<b-card>
				<div class="display-table full-width mb-2">
					<strong class="card-title">{{$route.meta.label}}</strong>
				</div>
				<b-row>
					<ResponseAlert ref="response" />
					<b-col sm="5" class="mb-2">
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('name')}" label="Name">
							<b-form-input v-model="models.name" v-validate="'required'" data-vv-name="name">
							</b-form-input>
							<div v-if="errors.has('name')">
								<p class="text-danger">{{ errors.first('name') }}</p>
							</div>
						</b-form-group>
						<b-form-group label="Status">
							<div class="col-sm-12 no-padding">
								<label class="radio-inline no-padding">
									<input type="radio" v-model="models.status" value="active">
									<span class="badge badge-success">Active</span>
								</label>
								<label class="radio-inline">
									<input type="radio" v-model="models.status" value="inactive">
									<span class="badge badge-danger">Inactive</span>
								</label>
							</div>
						</b-form-group>
					</b-col>
				</b-row>
				<template #footer>
					<b-button type="submit" variant="primary" class="btn-min-width rounded float-left">
						Save
					</b-button>
					<b-button type="button" variant="light" class="btn-min-width rounded float-left" @click="$router.push({name: config.uri})">
						Cancel
					</b-button>
				</template>
			</b-card>
		</div>
	</form>
</template>
<script>
import moment from 'moment'
import api from '@/utils/api.js'
import ResponseAlert from '@/components/response_alert';

export default {
	name: 'ListPodcastcategory',
	components: {
		ResponseAlert
	},
	data() {
		return {
			config: {
				uri: this.$route.meta.permission.link,
			},
			models: {
				name: "",
				status: "publish"
			},
			vars: {
				onLoadData: false,
			},
			moment
		}
	},
	created() {
		let _ = this
		_.getById();
	},
	methods: {
		getById() {
			const _ = this;
			if (_.$route.params.id) {
				_.vars.onLoadData = true
				_.$axios.get(`${api.podcast_category}/${_.$route.params.id}`)
					.then(res => {
						const { data } = res.data;
						_.models.name = data.name,
							_.models.status = data.status

						this.$nextTick(() => {
							_.vars.onLoadData = false
						});
					}).catch(() => {
						_.vars.onLoadData = false
						_.$router.push({
							name: 'page404'
						})
					});
			}
		},

		save() {
			const _ = this;
			_.$validator.validate().then(valid => {
				if (valid) {
					let request = "";
					let message = "create"
					console.log(_.models);
					if (!_.$route.params.id) {
						request = _.$axios.post(api.podcast_category, _.models);
					} else {
						message = "update"
						request = _.$axios.put(`${api.podcast_category}/${_.$route.params.id}`, _.models);
					}
					request
						.then(() => {
							this.$showToast('Success', `Success ${message} podcast`)
							console.log(_.config.uri)
							_.$router.push({
								name: _.config.uri
							})
						})
						.catch(error => _.$refs.response.setResponse(error.response.data.message, 'danger'));
				} else {
					window.scrollTo(0, 0);
				}
			});
		}
	},
}
</script>